module.exports = __webpack_public_path__ + "static/media/thedyrt.com-gear.dbef513b.png";